/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
} from './ChallengeType';
import type { PasswordSetAttestationData } from './PasswordSetAttestationData';
import {
    PasswordSetAttestationDataFromJSON,
    PasswordSetAttestationDataFromJSONTyped,
    PasswordSetAttestationDataToJSON,
} from './PasswordSetAttestationData';

/**
 * 
 * @export
 * @interface PasswordSetAttestation
 */
export interface PasswordSetAttestation {
    /**
     * 
     * @type {string}
     * @memberof PasswordSetAttestation
     */
    challenge_id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof PasswordSetAttestation
     */
    challenge_type: ChallengeType;
    /**
     * 
     * @type {PasswordSetAttestationData}
     * @memberof PasswordSetAttestation
     */
    data?: PasswordSetAttestationData;
}

/**
 * Check if a given object implements the PasswordSetAttestation interface.
 */
export function instanceOfPasswordSetAttestation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "challenge_id" in value;
    isInstance = isInstance && "challenge_type" in value;

    return isInstance;
}

export function PasswordSetAttestationFromJSON(json: any): PasswordSetAttestation {
    return PasswordSetAttestationFromJSONTyped(json, false);
}

export function PasswordSetAttestationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordSetAttestation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'challenge_id': json['challenge_id'],
        'challenge_type': ChallengeTypeFromJSON(json['challenge_type']),
        'data': !exists(json, 'data') ? undefined : PasswordSetAttestationDataFromJSON(json['data']),
    };
}

export function PasswordSetAttestationToJSON(value?: PasswordSetAttestation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'challenge_id': value.challenge_id,
        'challenge_type': ChallengeTypeToJSON(value.challenge_type),
        'data': PasswordSetAttestationDataToJSON(value.data),
    };
}

